import './Package.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleChevronRight,
  faCircleXmark,
  faClockRotateLeft,
  faForward,
  faRandom,
  faSearch,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { getDGText } from './PackageUtils';

const Package = ({
  disableButtons,
  individualPackage,
  openModal,
  bays,
  racks,
  specialActionType,
  specialAction,
}) => {
  const getCurrentBay = () => {
    const racksArray =
      racks &&
      Object.keys(racks)
        .map(key => racks[key])
        .flat();

    if (bays?.find(bay => bay.id == individualPackage?.bayId)) {
      const bay = bays?.find(bay => bay.id == individualPackage?.bayId);
      return `${bay.bayType[0]}${bay.bayNumber}`.toUpperCase();
    } else if (racksArray?.find(bay => bay.id == individualPackage?.bayId)) {
      const bay = racksArray?.find(bay => bay.id == individualPackage?.bayId);
      return `R${bay.bayNumber}`.toUpperCase();
    } else {
      return 'None';
    }
  };

  const getSpecialActionButtonContent = () => {
    switch (specialActionType) {
      case 'add_unit':
        return 'Unload';
      case 'go_to_delivery':
        return <FontAwesomeIcon icon={faSearch} className="search_icon" />;
      case 'remove_unit':
        return <FontAwesomeIcon icon={faXmark} className="remove_unit_icon" />;
      case 'undo_manually_complete':
        return <FontAwesomeIcon icon={faClockRotateLeft} className="undo_manually_complete_icon" />;
      case 'manually_complete':
        return <FontAwesomeIcon icon={faForward} className="manually_complete_icon" />;
      case 'bay_assign':
        return <FontAwesomeIcon icon={faRandom} className="bay_assign_icon" />;
      case 'bay_remove':
        return <FontAwesomeIcon icon={faCircleXmark} className="bay_remove_icon" />;
      case 'bay_add':
        return <FontAwesomeIcon icon={faCircleChevronRight} className="bay_add_icon" />;
      default:
        return getCurrentBay();
    }
  };

  const handleButtonClick = type => {
    if (!disableButtons) {
      if (type != 'hazard' || individualPackage?.job?.cargoHazardous) {
        openModal(
          type,
          `${individualPackage?.job?.jobReference}-${individualPackage?.packageNumber}`,
          individualPackage,
        );
      }
    }
  };

  return (
    <div className="package_information">
      <div
        className={`details ${disableButtons && 'disabled'}`}
        onClick={() => handleButtonClick('details')}
      >
        <span className="package_ref">
          {individualPackage?.job?.jobReference}-{individualPackage?.packageNumber}
        </span>
        <span className="num_items">
          {!individualPackage?.verified && 'Said to contain'}
          {individualPackage?.quantity} item{individualPackage?.quantity > 1 && 's'}
        </span>
        <span className="package_weight">{individualPackage?.grossWeightKg || '???'} kg</span>
        <span className="package_cubic">
          {individualPackage?.cubicMetres || '0.00'}
          m³
        </span>
        {(individualPackage?.lengthCm ||
          individualPackage?.widthCm ||
          individualPackage?.heightCm) && (
          <span className="package_dimensions">
            {individualPackage?.lengthCm || '?'} x {individualPackage?.widthCm || '?'} x
            {individualPackage?.heightCm || ' ? '}
            cm
          </span>
        )}
      </div>
      <div
        className={`package ${disableButtons && 'disabled'}`}
        onClick={() => handleButtonClick('package')}
      >
        {individualPackage?.packageType?.shortName || '???'}
        <div className={`damaged_status ${individualPackage?.damaged && 'damaged'}`}>
          {individualPackage?.damaged ? (
            <>
              <FontAwesomeIcon icon={faWarning} className="danger" />
              Damaged
            </>
          ) : (
            'OK'
          )}
        </div>
      </div>
      <div
        className={`hazard ${
          (!individualPackage?.job?.cargoHazardous || disableButtons) && 'disabled'
        }`}
        onClick={() => handleButtonClick('hazard')}
      >
        {individualPackage?.job?.cargoHazardous ? (
          <div className="hazardous">
            <span>{`${
              individualPackage?.dangerousGoodsAssociations?.length > 0
                ? individualPackage?.dangerousGoodsAssociations?.length
                : 'No'
            } DG${
              individualPackage?.dangerousGoodsAssociations?.length > 1 ||
              individualPackage?.dangerousGoodsAssociations?.length == 0
                ? 's'
                : ''
            }`}</span>
            {individualPackage?.dangerousGoodsAssociations?.length == 0
              ? 'No labels required'
              : getDGText(individualPackage)}
          </div>
        ) : (
          'Non-hazardous job'
        )}
      </div>

      <button
        className={`special ${specialActionType} ${!specialAction ? 'disabled' : ''}`}
        data-testid={`special_button_${specialActionType}`}
        onClick={() => specialAction(individualPackage?.id)}
        disabled={!specialAction}
      >
        {getSpecialActionButtonContent()}
      </button>
    </div>
  );
};

Package.propTypes = {
  disableButtons: PropTypes.bool,
  individualPackage: PropTypes.object,
  openModal: PropTypes.func,
  bays: PropTypes.array,
  racks: PropTypes.object,
  specialActionType: PropTypes.string,
  specialAction: PropTypes.func,
};

export default Package;
